import React from "react";
import { Container } from "@material-ui/core";
import { Grid } from "@material-ui/core";

import Heading from '../../Components/sectionHeading'

import aboutimg from '../../images/Aboutgraphics.png'
import textimg from '../../images/textimg.png'

import clockwise from '../../images/Clockwise.png'
import lock from '../../images/Lock.png'
import web from '../../images/Web.png'
import paper from '../../images/Paper.png'
import idcard from '../../images/ID.png'
import moonguy from '../../images/moonguy.png'


const About = () => {
  return (
    <div id='introduction' className="pt-5">
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="QMF---About pb-5 my-5"
        >
          <Grid
              xs={12}
          >
            <Heading 
                title="About"
                // subtitle="WHAI AND why"
            />
          </Grid>
          <Grid
              xs={12}
              sm={6}
              className="py-sm-5"
          >
              <h3>
              FMF Token is a hyper-deflationary 
                  <br className="d-none d-md-block" /> DeFi token built to succeed!
              </h3>
              <p className="text-light mt-4">
              Each transaction incurs a 12% tax. This is because FTMMOON is squarely aimed at long term holders who want their tokens to do the work for them. This does not mean that trading isn't a part of the healthy ecosystem though, as buying and selling contribute to making the project more profitable and sustainable in the long run.
              </p>            
          </Grid>
          <Grid
              xs={12}
              sm={6}
              className="text-center"
              className="text-center pt-3 my-5"
          >
              {/* <img src={aboutimg} alt="Header Image" className="img-fluid w-100" style={{maxWidth: 450}} /> */}
              <div id="circle-orbit-container">

            <img src={moonguy} className="fmm---circle_img fmm---cntr-circle_img" />
              <div id="outer-orbit">
                <img src={clockwise}  className="img-fluid w-100" />
                <img src={lock} className="fmm---circle_img fmm---circle_img1" />
                <img src={web} className="fmm---circle_img fmm---circle_img2" />
                <img src={paper} className="fmm---circle_img fmm---circle_img3" />
                <img src={idcard} className="fmm---circle_img fmm---circle_img4" />
              </div>
            </div>
          </Grid>
          <Grid
              xs={12}
              className="py-4 my-5"
          >
            <img src={textimg} alt="Header Image" className="img-fluid" />
            
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default About;
